/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortDto } from './sortDto';


export interface TenantFilterDto { 
    name?: string;
    type?: TenantFilterDto.TypeEnum;
    contractorNumber?: string;
    facilityElement?: TenantFilterDto.FacilityElementEnum;
    externalTenantId?: string;
    managementView?: boolean;
    text?: string;
    page?: number;
    sort?: SortDto;
    size?: number;
}
export namespace TenantFilterDto {
    export type TypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TypeEnum = {
        Internal: 'Internal' as TypeEnum,
        External: 'External' as TypeEnum,
        Contractor: 'Contractor' as TypeEnum
    };
    export type FacilityElementEnum = 'ABLESEUNTERNEHMEN' | 'ANLAGE' | 'AUFZUG' | 'AUTOPARKSYSTEM' | 'BM_ANLAGE' | 'BAUM_UND_STRAUCHSCHNITT' | 'BAUMEISTER' | 'BRAND_UND_WASSERSCHADENSANIERUNG' | 'BRANDSCHUTZBEAUFTRAGTER' | 'BRANDSCHUTZKLAPPE' | 'BRANDSCHUTZTOR' | 'CO_WARNANLAGE' | 'DACHDECKER' | 'ELEKTRIKER' | 'ENTRUEMPELUNG' | 'FENSTER' | 'FEUERLOESCHER' | 'FLIESENLEGER' | 'GARAGENTOR' | 'GASTHERME' | 'GEWAEHRLEISTUNG' | 'GLASEREI' | 'GRUENFLAECHENBETREUUNG' | 'HAUSBETREUUNG' | 'HEIZANLAGE' | 'INSTALLATEUR' | 'KAMINSANIERUNG' | 'KANALVERSTOPFUNG_KAMERA' | 'KLEINREPARATUR' | 'MALER' | 'NASSSTEIGLEITUNG' | 'NEU' | 'RWA_ANLAGE' | 'RAUCHFANGKEHRER' | 'SALZ_UND_DOSIERUNG' | 'SCHLOSSER' | 'SCHRANKENANLAGE' | 'SCHAEDLINGSBEKAEMPFUNG' | 'SONNENSCHUTZ' | 'SPENGLER' | 'SPIELGERAETE_WARTUNG_REPARATUR' | 'TISCHLER' | 'TROCKENSTEIGLEITUNG' | 'WASCHKUECHE_GERAET' | 'WASCHKUECHE_ZAEHLER' | 'WASSERAUFBEREITUNG' | 'WINTERDIENST' | 'WOHNRAUMLUEFTUNG';
    export const FacilityElementEnum = {
        Ableseunternehmen: 'ABLESEUNTERNEHMEN' as FacilityElementEnum,
        Anlage: 'ANLAGE' as FacilityElementEnum,
        Aufzug: 'AUFZUG' as FacilityElementEnum,
        Autoparksystem: 'AUTOPARKSYSTEM' as FacilityElementEnum,
        BmAnlage: 'BM_ANLAGE' as FacilityElementEnum,
        BaumUndStrauchschnitt: 'BAUM_UND_STRAUCHSCHNITT' as FacilityElementEnum,
        Baumeister: 'BAUMEISTER' as FacilityElementEnum,
        BrandUndWasserschadensanierung: 'BRAND_UND_WASSERSCHADENSANIERUNG' as FacilityElementEnum,
        Brandschutzbeauftragter: 'BRANDSCHUTZBEAUFTRAGTER' as FacilityElementEnum,
        Brandschutzklappe: 'BRANDSCHUTZKLAPPE' as FacilityElementEnum,
        Brandschutztor: 'BRANDSCHUTZTOR' as FacilityElementEnum,
        CoWarnanlage: 'CO_WARNANLAGE' as FacilityElementEnum,
        Dachdecker: 'DACHDECKER' as FacilityElementEnum,
        Elektriker: 'ELEKTRIKER' as FacilityElementEnum,
        Entruempelung: 'ENTRUEMPELUNG' as FacilityElementEnum,
        Fenster: 'FENSTER' as FacilityElementEnum,
        Feuerloescher: 'FEUERLOESCHER' as FacilityElementEnum,
        Fliesenleger: 'FLIESENLEGER' as FacilityElementEnum,
        Garagentor: 'GARAGENTOR' as FacilityElementEnum,
        Gastherme: 'GASTHERME' as FacilityElementEnum,
        Gewaehrleistung: 'GEWAEHRLEISTUNG' as FacilityElementEnum,
        Glaserei: 'GLASEREI' as FacilityElementEnum,
        Gruenflaechenbetreuung: 'GRUENFLAECHENBETREUUNG' as FacilityElementEnum,
        Hausbetreuung: 'HAUSBETREUUNG' as FacilityElementEnum,
        Heizanlage: 'HEIZANLAGE' as FacilityElementEnum,
        Installateur: 'INSTALLATEUR' as FacilityElementEnum,
        Kaminsanierung: 'KAMINSANIERUNG' as FacilityElementEnum,
        KanalverstopfungKamera: 'KANALVERSTOPFUNG_KAMERA' as FacilityElementEnum,
        Kleinreparatur: 'KLEINREPARATUR' as FacilityElementEnum,
        Maler: 'MALER' as FacilityElementEnum,
        Nasssteigleitung: 'NASSSTEIGLEITUNG' as FacilityElementEnum,
        Neu: 'NEU' as FacilityElementEnum,
        RwaAnlage: 'RWA_ANLAGE' as FacilityElementEnum,
        Rauchfangkehrer: 'RAUCHFANGKEHRER' as FacilityElementEnum,
        SalzUndDosierung: 'SALZ_UND_DOSIERUNG' as FacilityElementEnum,
        Schlosser: 'SCHLOSSER' as FacilityElementEnum,
        Schrankenanlage: 'SCHRANKENANLAGE' as FacilityElementEnum,
        Schaedlingsbekaempfung: 'SCHAEDLINGSBEKAEMPFUNG' as FacilityElementEnum,
        Sonnenschutz: 'SONNENSCHUTZ' as FacilityElementEnum,
        Spengler: 'SPENGLER' as FacilityElementEnum,
        SpielgeraeteWartungReparatur: 'SPIELGERAETE_WARTUNG_REPARATUR' as FacilityElementEnum,
        Tischler: 'TISCHLER' as FacilityElementEnum,
        Trockensteigleitung: 'TROCKENSTEIGLEITUNG' as FacilityElementEnum,
        WaschkuecheGeraet: 'WASCHKUECHE_GERAET' as FacilityElementEnum,
        WaschkuecheZaehler: 'WASCHKUECHE_ZAEHLER' as FacilityElementEnum,
        Wasseraufbereitung: 'WASSERAUFBEREITUNG' as FacilityElementEnum,
        Winterdienst: 'WINTERDIENST' as FacilityElementEnum,
        Wohnraumlueftung: 'WOHNRAUMLUEFTUNG' as FacilityElementEnum
    };
}


